import AssistantPromptCard, { Props as AssistantPromptProps } from '@/widgets/v2/AI/AssistantPrompt'
import React from 'react'
import SVG from 'react-inlinesvg'
import * as style from './style'
import { useAssistantPromptCardLayout } from '@/hooks/useAssistantPromptCardLayout'

export interface Props {
  id?: string
  items: AssistantPromptProps[]
  className?: string
}

const PartnerAssistantPromptsBlock = ({ id, items, className = '' }: Props): JSX.Element => {
  const { numberOfItemsToDisplay, isMaxNumberOfItemsToDisplay, onViewMoreItems } = useAssistantPromptCardLayout(
    items.length,
  )

  const promptCardsToShow = items.slice(0, numberOfItemsToDisplay)
  const moreToView = items.length > numberOfItemsToDisplay && !isMaxNumberOfItemsToDisplay
  const promptCardsNotShown = items.slice(promptCardsToShow.length, items.length)

  return (
    <section id={id ?? undefined} className={`${className} px-0 py-3 md:py-6`}>
      <h2 className={`${style.heading} leading-7 mb-1`}>What other members are asking Helen</h2>
      <p className={`${style.subHeading} text-primary`}>
        Learn how Helen handles real-world tasks through step-by-step replays.
      </p>
      <div className={`mt-4 xxxl:mt-6 ${style.grid}`}>
        <Cards items={promptCardsToShow} />
      </div>
      <div style={{ display: 'none' }} aria-hidden>
        <ShadowCards items={promptCardsNotShown} />
      </div>
      {moreToView && (
        <div className={`${style.seeMore}  before:border-y-grey pt-8 before:border-t before:border-solid`}>
          <button
            data-distinction={id}
            onClick={onViewMoreItems}
            className="group text-primary bg-transparent no-underline whitespace-nowrap pl-4 border-0 uppercase cursor-pointer transition-colors duration-200 ease-out"
          >
            <div className="flex justify-center align-middle">
              <span className="font-bold text-sm mr-1 leading-5">View More</span>
              <div className="h-[14px] overflow-hidden">
                <div className="mt-[-18px] gap-1 transition-all duration-300 ease-out group-hover:mt-0">
                  <SVG
                    className="h-[14px] w-auto"
                    src={'https://gsuimages.com/icons/chev-down.svg'}
                    cacheRequests={true}
                  />
                  <SVG
                    className="h-[14px] w-auto"
                    src={'https://gsuimages.com/icons/chev-down.svg'}
                    cacheRequests={true}
                  />
                </div>
              </div>
            </div>
          </button>
        </div>
      )}
    </section>
  )
}

const Cards = ({ items }: { items: AssistantPromptProps[] }): JSX.Element => {
  return (
    <>
      {items.map((item, index) => (
        <AssistantPromptCard key={index} {...(item as AssistantPromptProps)} />
      ))}
    </>
  )
}

const ShadowCards = ({ items }: { items: AssistantPromptProps[] }): JSX.Element => {
  return (
    <>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.label ? <AssistantPromptCard {...(item as AssistantPromptProps)} /> : null}
        </React.Fragment>
      ))}
    </>
  )
}

export default PartnerAssistantPromptsBlock
